"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RestUtils {
    static getHostPageBaseURL() {
        let s = document.location.href;
        // Pull off any hash.
        let i = s.indexOf("#");
        if (i !== -1) {
            s = s.substring(0, i);
        }
        // Pull off any query string.
        i = s.indexOf("?");
        if (i !== -1) {
            s = s.substring(0, i);
        }
        // Rip off everything after the last slash.
        i = s.lastIndexOf("/");
        if (i !== -1) {
            s = s.substring(0, i);
        }
        // Ensure a final slash if non-empty.
        return s.length > 0 ? s + "/" : "";
    }
    static compare(o1, o2) {
        const o1String = typeof o1 === "string" ? o1 : o1.prefix;
        const o2String = typeof o2 === "string" ? o2 : o2.prefix;
        return RestUtils.compareStr(o1String, o2String);
    }
    static compareStr(s1, s2) {
        if (s1 < s2) {
            return -1;
        }
        else if (s1 > s2) {
            return 1;
        }
        else {
            return 0;
        }
    }
    static extractPathFromUrl(url) {
        let begin = url.indexOf("//");
        if (begin === -1) {
            begin = 0;
        }
        else {
            begin = url.indexOf("/", begin + 2);
        }
        let end = url.indexOf("?", begin);
        if (end === -1) {
            end = url.indexOf("#", begin);
            if (end === -1) {
                end = url.length;
            }
        }
        return url.substring(begin, end);
    }
}
exports.default = RestUtils;
//# sourceMappingURL=RestUtils.js.map